export const REQUISITION_STATUS = {
  DRAFT: 'draft',
  AWAITING_BUYER_REVIEW: 'awaiting_buyer_review',
  APPROVED: 'approved',
  PARTIALLY_APPROVED: 'partially_approved',
  REJECTED: 'rejected',
} as const

export type RequisitionStatus =
  (typeof REQUISITION_STATUS)[keyof typeof REQUISITION_STATUS]

export type RequisitionOutcome =
  typeof REQUISITION_STATUS.APPROVED | typeof REQUISITION_STATUS.REJECTED
